<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-md-6 offset-md-3">

          <div v-if="!submitted">
            <h1 class="title">Join Us</h1>

            <p>You can join us, either as a member or as a client (or both).</p>

            <b-form @submit.prevent="submit">
              <b-form-group label="Your name:">
                <b-form-input id="name"
                              type="text"
                              v-model="form.first_name"
                              required>
                </b-form-input>
              </b-form-group>
              <b-form-group label="Email:">
                <b-form-input id="email"
                              type="email"
                              v-model="form.email"
                              required>
                </b-form-input>
              </b-form-group>
              <b-form-group label="Choose a Password:">
                <b-form-input id="password"
                              type="password"
                              v-model="form.password"
                              required>
                </b-form-input>
              </b-form-group>
              <b-form-group
                label="Company name:"
                description="If joining as a company, please enter your company name.">
                <b-form-input id="company"
                              type="text"
                              v-model="form.company">
                </b-form-input>
              </b-form-group>
              <b-form-group label="Website:">
                <b-form-input id="website"
                              type="url"
                              v-model="form.website">
                </b-form-input>
              </b-form-group>
              <b-form-group
                label="About you:"
                description="Share some links to what you've created, or just a few words about your work.">
                <b-form-textarea id="about"
                                v-model="form.about"
                                :rows="5"
                                :max-rows="10">
                </b-form-textarea>
              </b-form-group>
              <div class="error" v-if="hasError">
                {{ this.errorInfo }}
              </div>
              <b-button type="submit" variant="primary">Sign Up &rarr;</b-button>
            </b-form>
          </div>
          <div v-else>
            <h1 class="title">Thank you.</h1>
            <p>
              We have received your application and we will be in touch via email very shortly.
            </p>
            <hr class="space space-sm">
            <router-link :to="{ name: 'home' }">&larr; Back to Home</router-link>
          </div>
        </div>
      </div>
    </div>
    <hr class="divider">
  </div>
</template>

<script>
export default {
  name: 'login',
  data () {
    return {
      form: {
        first_name: null,
        email: null,
        password: null,
        company: null,
        website: null,
        about: null
      },
      submitted: false,
      hasError: false,
      errorInfo: null
    }
  },
  methods: {
    submit () {
      this.hasError = false
      const { form } = this
      this.$store.dispatch('REGISTER', form).then((response) => {
        this.submitted = true
      }, error => {
        console.log('error', error)
        this.hasError = true
        this.errorInfo = 'Something didn\'t work. Please try again.'
        if (error.response && error.response.data) {
          this.errorsInfo = error.response.data
        }
      })
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  computed: {
  },
  created () {
  }
}
</script>

<style lang="scss">
</style>
